// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__21bu7","header":"ReportDetails_header__1_4T_","title":"ReportDetails_title__LLUG0","left":"ReportDetails_left__3bYvS"};